import React from 'react'
import Spacer from '../../../components/Spacer';
import Banner from '../../../components/Banner';
import Info from './Info';
import BannerInfo from './BannerInfo';
import InfoTwo from './InfoTwo';


function CatalogOg() {
  return (
    <>
    <Banner titleSection={'CATALOGO DE OG (objetos geográficos) y de METADATOS'} linkName={'Inicio'} nameSection={'Catalogo de Objetos Geográficos(OG)'} />
    <Spacer/>
    <BannerInfo/>
    <Spacer/>
    <Info/>
    <Spacer/>
    <InfoTwo/>
    <Spacer/>
    </>
  )
}

export default CatalogOg